<!-- section start -->

<div>
    <section class="section_one">
        <div class="">
            <div class="row">
                <div class="col-md-12">
                    <div class="ibox">
                        <div class="ibox-content">
                            <mat-card *ngIf="showbipc">
                                <div class="searchpaginator">
                                    <ul class="bipcper_list">
                                        <li>No of Exams : {{this.parentData.noOfExams}}</li>
                                        <li>Physics : {{this.parentData.physicsPer}}%</li>
                                        <li>Chemistry : {{this.parentData.chemistryPer}}%</li>
                                        <li>Bontany : {{this.parentData.botanyPercentage}}%</li>
                                        <li>Zoology : {{this.parentData.ZoologyPer}}%</li>
                                    </ul>

                                </div>
                                <div class="table-responsive">
                                    <mat-card-content>
                                        <table mat-table [dataSource]="progressReport" matSort class="table_resize">
                                            <ng-container matColumnDef="testCode">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="resizer"
                                                    appResizableColumns>Test Code
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.testCode}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="testDate">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns> Test Date
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.testDate}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="total">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Total
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.total}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="totalMaxMarks">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Total Max Marks
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.totalMaxMarks}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="botany">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Botany
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.botany}}
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="physics">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Physics
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    <span>{{row.physics}}</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="chemistry">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Chemistry
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    <span>{{row.chemistry}}</span>
                                                </td>
                                            </ng-container>

                                            <!-- Zoology Subject -->

                                            <ng-container matColumnDef="zoology">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Zoology
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    <span>{{row.zoology}}</span>
                                                </td>
                                            </ng-container>

                                            <!--End Zoology Subject -->

                                            <tr mat-header-row *matHeaderRowDef="BipcdisplayedColumns  sticky: true">
                                            </tr>
                                            <tr mat-row *matRowDef="let row; columns: BipcdisplayedColumns;"></tr>

                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" class="not_matchdata" colspan="8">No data
                                                    matching the filter
                                                </td>
                                            </tr>
                                        </table>
                                    </mat-card-content>
                                </div>
                            </mat-card>

                            <!-- MPC TABLE -->

                            <mat-card *ngIf="showMpc">
                                <div class="searchpaginator">
                                    <ul class="mpcper_list">
                                        <li>No Of Exams : {{this.parentData.noOfExams}}</li>
                                        <li>Maths : {{this.parentData.mathsPercentage}}%</li>
                                        <li>Physics : {{this.parentData.physicsPer}}%</li>
                                        <li>Chemistry : {{this.parentData.chemistryPer}}%</li>
                                    </ul>
                                </div>

                                <div class="table-responsive">
                                    <mat-card-content>
                                        <table mat-table [dataSource]="progressReport" matSort class="table_resize">
                                            <ng-container matColumnDef="testCode">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="resizer"
                                                    appResizableColumns>Test Code
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.testCode}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="testDate">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns> Test Date
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: left;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.testDate}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="total">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Total
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.total}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="totalMaxMarks">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Total Max Marks
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.totalMaxMarks}} </td>
                                            </ng-container>
                                            <ng-container matColumnDef="maths">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Maths
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    {{row.maths}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="physics">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Physics
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    <span>{{row.physics}}</span>
                                                </td>
                                            </ng-container>

                                            <ng-container matColumnDef="chemistry">
                                                <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                    appResizableColumns>Chemistry
                                                    <i class="fa fa-fw fa-sort"></i>
                                                </th>
                                                <td mat-cell *matCellDef="let row" style="text-align: right;"
                                                    [ngClass]="{'highlighted': isSelected(row)}" (click)="allMarks(row)"
                                                    class="working_txt">
                                                    <span>{{row.chemistry}}</span>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="MpcdisplayedColumns  sticky: true">
                                            </tr>
                                            <tr mat-row *matRowDef="let row; columns: MpcdisplayedColumns;"></tr>

                                            <tr class="mat-row" *matNoDataRow>
                                                <td class="mat-cell" class="not_matchdata" colspan="7">No data
                                                    matching the filter
                                                </td>
                                            </tr>
                                        </table>
                                    </mat-card-content>
                                </div>
                            </mat-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>